<template>
  <v-app>
    <router-view/>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
    }
  }
}
</script>

<style>
.alert-box{
  position:fixed;
  width:100%;
  z-index: 9;
}
</style>